import dayjs from 'dayjs';
import { getCountryCode } from '../UserInvitation/userInvitation';

const USA_Cvd_Url = 'https://2q810fiqe6.execute-api.us-east-2.amazonaws.com/api/globalDeclaration';
const Aus_Cvd_Url = 'https://zktnfdzz79.execute-api.ap-southeast-2.amazonaws.com/api/declaration';

export const getCvdUrl = (env) => {
  switch (env) {
    case 'development':
      return USA_Cvd_Url;
    case 'stage':
      return USA_Cvd_Url;
    case 'production':
      return USA_Cvd_Url;
    case 'au_development':
      return Aus_Cvd_Url;
    case 'au_stage':
      return Aus_Cvd_Url;
    case 'au_production':
      return Aus_Cvd_Url;
    default:
      return Aus_Cvd_Url;
  }
};
const countryPhoneCode = getCountryCode(process.env.REACT_APP_ENV);

const Usa_values = {
  vendorName: '',
  vendorAddress: '',
  vendorTown: '',
  vendorState: '',
  vendorContact: '',
  vendorFax: '',
  vendorEmail: '',
  vendorNGR: '',
  vendorPremiseId: '',
  premiseId: '',
  vendorReference: '',
  vendorPostalCode: '',
  buyerPostalCode: '',
  buyerName: '',
  buyerAddress: '',
  buyerTown: '',
  buyerState: '',
  buyerContact: countryPhoneCode,
  buyerFax: '',
  buyerEmail: '',
  buyerNGR: '',
  buyerPremiseId: '',
  buyerReference: '',
  commodity1: '',
  commodity2: '',
  period: dayjs(new Date()),
  variety1: '',
  variety2: '',
  quantity1: 0,
  quantity2: 0,
  unit1: '',
  unit2: '',
  sourceCheck: '',
  materialCheck: '',
  gmoCheck: '',
  chemicalCheck: '',
  driverName: '',
  driverEmail: '',
  driverContact: countryPhoneCode,
  driverCompanyName: '',
  companyName: '',
  registration: '',
  chemicals: [],
  qaCheck: '',
  qaProgram: '',
  certificateNumber: '',
  cvdCheck: '',
  cropList: [],
  riskCheck: '',
  nataCheck: '',
  signature: '',
  riskAssesment: '',
  testResult: '',
};

const AUS_values = {
  vendorName: '',
  vendorAddress: '',
  vendorTown: '',
  vendorState: '',
  vendorContact: '',
  vendorFax: '',
  vendorEmail: '',
  vendorNGR: '',
  vendorPIC: '',
  premiseId: '',
  vendorReference: '',
  vendorPostalCode: '',
  buyerPostalCode: '',
  buyerName: '',
  buyerAddress: '',
  buyerTown: '',
  buyerState: '',
  buyerContact: countryPhoneCode,
  buyerFax: '',
  buyerEmail: '',
  buyerNGR: '',
  buyerPIC: '',
  buyerReference: '',
  commodity1: '',
  commodity2: '',
  period: dayjs(new Date()),
  variety1: '',
  variety2: '',
  quantity1: 0,
  quantity2: 0,
  unit1: '',
  unit2: '',
  sourceCheck: '',
  materialCheck: '',
  gmoCheck: '',
  chemicalCheck: '',
  driverName: '',
  driverEmail: '',
  driverContact: countryPhoneCode,
  driverCompanyName: '',
  companyName: '',
  registration: '',
  chemicals: [],
  qaCheck: '',
  qaProgram: '',
  certificateNumber: '',
  cvdCheck: '',
  cropList: [],
  riskCheck: '',
  nataCheck: '',
  signature: '',
  riskAssesment: '',
  testResult: '',
};

export const getCvdValues = (env) => {
  switch (env) {
    case 'development':
      return Usa_values;
    case 'stage':
      return Usa_values;
    case 'production':
      return Usa_values;
    case 'au_development':
      return AUS_values;
    case 'au_stage':
      return AUS_values;
    case 'au_production':
      return AUS_values;
    default:
      return AUS_values;
  }
};
